/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  
  Modified by yang@onerockwell
  
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.addMultipleItems = function(data, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart');
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item);
                } else {
                    ShopifyAPI.onItemAdded(line_item);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    let formSibling = form.previousElementSibling,
    itemUrl = '';

    console.log(form);
    var addItemOriginal = function() {
        var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                } else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
        jQuery.ajax(params);
    }

    // Limit item quantity
    var stopAddItem = false;
    var limitQty = true;
    var addingQty = 1;
    var itemData;
    var itemId;

    if (window.location.pathname.indexOf('/products/') !== -1) {
        console.log("this is PDP")
        // standard way of getting product data from product JSON available on PDPs
        var itemHTML = form.querySelector('[data-product-json]').textContent;
        if (itemHTML) {
            itemData = JSON.parse(itemHTML);
            itemId = itemData.id;
        }
        itemUrl = location.protocol + '//' + location.host + location.pathname;
    } else{
        console.log("not PDP");
        // FastSimon product cards on PLP don't have the ususal product-core-form so we can't get JSON data from there
        // get product ID from object created in isp-js.liquid
        itemId = form.querySelector('meta[itemprop="product_id"]').content;
        itemUrl = formSibling.querySelector('a').href;
    }

    // If item is limited, check cart state for item and if item is at max or if qty being added would go above the max

    let productData,
    typeCount = 0;

    const result = fetch(`${itemUrl}.json`)
    .then((response) => response.json())
    .then((data) => {
        console.log('success');
        productData = data.product;
        return fetch('/cart', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        });
    })
    .then((response) => response.json())
    .then(r => { 
        let productType = productData.product_type;
        if (limitQty) {
            var qtyMax = 1;
            if (addingQty > qtyMax) {
                console.log(`Quantity is restricted to ${qtyMax}`);
                return;
            }

            for (let item of r.items) {
                    
                    if(item.product_type === productType && productType === 'Broadloom'){
                        typeCount++;
                    }
                    
                    // this checks if you are a sales team member
                    if( $('#Marketing-sales').length ) {
                        //yes this person is, so it allows to add more
                    } else {
                        if (item.id === itemId && ((item.quantity + addingQty) > qtyMax) || 
                        (productType == 'Broadloom' && typeCount >= 15) ) {
                            stopAddItem = true;
                            if(productType == 'Broadloom' && typeCount >= 15){
                                if(document.querySelector('#myModal')){
                                    document.querySelector('#myModal').style.display = 'block';
                                }
                            }
                        }
                    }
                }
                if (!stopAddItem) {
                    addItemOriginal(); 
                    if(document.querySelector(`#form_${itemId}`)){
                        document.querySelector(`#form_${itemId}`).style.display = 'none';
                    }
                }else{
                    return;
                }
        }else {
            addItemOriginal();
            if(document.querySelector(`#form_${itemId}`)){
                document.querySelector(`#form_${itemId}`).style.display = 'none';
            }
        }
    })
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};



/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function(variant, selector) {
    // var moneyFormat = Shopify.money_format;
    var moneyFormat = theme.moneyFormat;
    // Selectors
    if (selector.domIdPrefix.split('-').length > 1) {
        var selectorArray = selector.domIdPrefix.split('-');
        var $addToCart = $('#AddToCart-' + selectorArray[1]);
    } else {
        var $addToCart = $('#AddToCart');
    }

    var $productWrapper = $addToCart.parents('.product-core'), // Defined the Product Dom Scope
        $productPrice = $productWrapper.find('.product-price'),
        $comparePrice = $productWrapper.find('.product-compare-price'),
        $addToCartText = $productWrapper.find('body:not(.template-product) .add-to-cart-text');

    // Variant
    if (variant) {
        // Select a valid variant if available
        if (variant.available) {
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass('disabled').prop('disabled', false);
            if ($addToCart.hasClass('pre-order')) {
                $addToCartText.html("Pre Order");
            } else {
                if ($addToCart.hasClass('textiles')) {
                    $addToCartText.html("Order Memo");
                } else {
                    $addToCartText.html("Order Sample");
                }
            }
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            
            if( $('#Marketing-sales').length ) {
                        //yes this person is, so it allows to add more
            } else {
                $addToCart.addClass('disabled').prop('disabled', true);
            }
            if (!$addToCart.hasClass('inquire')) {
                $addToCartText.html("Sample Unavailable");
            }
        }
        // console.log('variant selected and update price');
        // console.log(selector);
        // Regardless of stock, update the product price
        $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
        } else {
            $comparePrice.hide();
        }

    } else {
        $addToCart.addClass('disabled').prop('disabled', true);
        if (!$addToCart.hasClass('inquire')) {
            $addToCartText.html("Sample Unavailable");
        }
    }
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCta, updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, additionalNote, productListToggle, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, cartLimit;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();

        // Add beautiful dropdown to additional select
        additionalNote();

        // Toggle product list on mobile
        productListToggle();
    };

    loadCart = function() {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function() {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();

            if (ORW.customer && !ORW.customer.loggedIn) {
                ORW.loginGate.requireLogin(window.location.pathname + window.location.search);
                return false;
            }

            var proceed = true;
            var $currForm = $(evt.target);
            var $selects = $currForm.find('select');
            $.each($selects, function(i, v) {
                if ($(v).val() == '') {
                    proceed = false;
                    return false;
                }
            });

            if (!proceed) {
                alert('Please select all options');
                return false;
            }

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $('.qty-error').remove();
            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);

            return false;
        });
    };

    itemAddedCallback = function(product) {
        if( $('#Marketing-sales').length ) {
            //yes this person is, so it allows to add more
            $addToCart.removeClass('is-adding')
            $('.product-form__input').val('1');
        } else {
        $addToCart.removeClass('is-adding').addClass('is-added');
        }
        updateCta();
        ShopifyAPI.getCart(function(cart) {
            let tempProduct = null;
            if(product){
                tempProduct = product
            }
            cartUpdateCallback(cart, tempProduct);
            $body.trigger('afterAddToCart.ajaxCart', cart);
        });
    };

    itemErrorCallback = function(res, text) {
        console.log(res);
        $addToCart.removeClass('is-adding is-added');

        if (!!text) {
            if (res.status == 422) {
                if(res.responseJSON){
                    $formContainer.after('<div class="errors qty-error">' + res.responseJSON.message + ': ' + res.responseJSON.description + '</div>')
                }else{
                    $formContainer.after('<div class="errors qty-error">' + text + '</div>')
                }
            }
        }
    };

    cartLimit = function(cart, product) {
        let productType = '',
            typeCount = 0;
        if(typeof product === 'object'){
            productType = product.product_type;
        }
       
        // Check if cart has any restricted quantity items exceeding the limit
            var qtyMax = 1;
            var cartUpdates = {};

            for (let item of cart.items) {
                if(item.product_type === productType && productType === 'Broadloom'){
                    typeCount++;
                }
                if (item.quantity > qtyMax) {
                    cartUpdates[item.id] = qtyMax;
                }
            }

            // Send cart update request only if has items exceeding max quantity
            
            // this checks if you are a sales team member
            if( $('#Marketing-sales').length ) {
                //yes this person is, so it allows to add more
            } else {
            
                if (Object.keys(cartUpdates).length > 0) {
                    if(productType !== 'Broadloom' || productType === 'Broadloom' && typeCount < 15){
                        const params = {
                            type: 'POST',
                            url: '/cart/update.js',
                            data: { updates: cartUpdates },
                            dataType: 'json',
                            success: function(cart) {
                                loadCart();
                                updateCountPrice(cart);
                                buildCart(cart);
                                // if (isCartPage()) location.reload();
                            },
                            error: function(XMLHttpRequest, textStatus) {
                                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                                ShopifyAPI.onError(XMLHttpRequest, textStatus);
                            },
                            complete: function(jqxhr, text) {
                                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
                            }
                        }
                        jQuery.ajax(params);
                    }
                }
            }
         
    }


    cartUpdateCallback = function(cart, product) {
        let tempProduct = product;
        cartLimit(cart, tempProduct);
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    updateCta = function() {
        if(document.querySelector('.template-product')){
            if( $('#Marketing-sales').length ) {
                        //yes this person is, so it allows to add more
            } else {
                if(document.querySelector('.block-cta .cta-1-medium.textiles')){
                    document.querySelector('.block-cta .cta-1-medium.textiles span').classList.add('out-of-stock');
                    document.querySelector('.block-cta .cta-1-medium.textiles span').innerHTML = 'Memo Added';
                }else{
                    if( $('#marketingBook').length ) {

                        document.querySelector('.block-cta .cta-1-medium span').classList.add('out-of-stock');
                        document.querySelector('.block-cta .cta-1-medium span').innerHTML = 'Book In Bag';

                    } else {
                        document.querySelector('.block-cta .cta-1-medium span').classList.add('out-of-stock');
                        document.querySelector('.block-cta .cta-1-medium span').innerHTML = 'Sample Added';
                    }

                    
                }
            }
        }
    }

    buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p class="ajaxcart__empty">' + "Your bag is currently empty." + '</p>');
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
             */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            var linePrice = Shopify.formatMoney(cartItem.line_price, settings.moneyFormat);

            var limitQty = true;
       

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                sku: cartItem.sku,
                color: cartItem.options_with_values[0].value,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                vendor: cartItem.vendor,
                linePrice: linePrice,
                originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
                priceFormatted: ORW.formatMoney(linePrice),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
                isGiftCard: cartItem.gift_card,
                limitQty: limitQty,
            };

            items.push(item);
        });

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
            totalCartDiscount: cart.total_discount === 0 ? 0 : "\u003cp\u003eYou're saving\u003c\/p\u003e".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
            totalItems: cart.item_count
        }

        $cartContainer.append(template(data));

        cartCallback(cart);
    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        $body.on('click', '.ajaxcart__qty-remove', function(e) {
            e.preventDefault();
            var $el = $(this),
                line = $el.data('line');

            if (isUpdating) {
                return;
            }
            updateQuantity(line, 0);
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    additionalNote = function (){
        if($(".cart-questions").length) {
            $('#interiorDesignerQuestion').select2({
                minimumResultsForSearch: -1,
                placeholder: "Select from the following options",
            });
            $('#pattersonFlynnAccountQuestion').select2({
                minimumResultsForSearch: -1,
                placeholder: "Select from the following options",
            });
            $('#pattersonFlynnAccountQuestion').on('change', function (e){
                let accountAnswer = $(this).val();
                if(accountAnswer === "Yes, I have a Patterson Flynn Sales Representative/Account Manager"){
                    $('#saleRepresentativeQuestion').attr('required', 'required').attr('name', 'attributes[Who is your Sales Representative/Account Manager]');
                    $('#saleRepresentativeQuestion').parent().removeClass('hide');
                }else{
                    $('#saleRepresentativeQuestion').removeAttr('required').attr('name', 'saleRepresentativeQuestion');
                    $('#saleRepresentativeQuestion').parent().addClass('hide');
                }
            });

            let savedAnswers = JSON.parse(localStorage.getItem('cartQuestionAnswers'));
            if(savedAnswers){
                if(savedAnswers.interiorDesignerQuestion){
                    $('#interiorDesignerQuestion').val(savedAnswers.interiorDesignerQuestion).trigger('change');
                }else{
                    $('#interiorDesignerQuestion').val('').trigger('change');
                }
                if(savedAnswers.pattersonFlynnAccountQuestion){
                    $('#pattersonFlynnAccountQuestion').val(savedAnswers.pattersonFlynnAccountQuestion).trigger('change');
                }else{
                    $('#pattersonFlynnAccountQuestion').val('').trigger('change');
                }
                if(savedAnswers.saleRepresentativeQuestion){
                    $('#saleRepresentativeQuestion').val(savedAnswers.saleRepresentativeQuestion);
                }else{
                    $('#saleRepresentativeQuestion').val('');
                }
            }else{
                $('#interiorDesignerQuestion').val('').trigger('change');
                $('#pattersonFlynnAccountQuestion').val('').trigger('change');
                $('#saleRepresentativeQuestion').val('');
            }
            $('#cartMainForm').on('submit', function (e){
                let answers = {
                    'interiorDesignerQuestion': $('#interiorDesignerQuestion').val(),
                    'pattersonFlynnAccountQuestion': $('#pattersonFlynnAccountQuestion').val(),
                    'saleRepresentativeQuestion': $('#saleRepresentativeQuestion').val()
                };
                localStorage.setItem('cartQuestionAnswers', JSON.stringify(answers));
            });
        }
    };

    productListToggle = function (){
        $('.cart-table-toggle').click(function (e){
           e.preventDefault();
            var $this = $(this);
            var div = $this.attr('href');
            $this.toggleClass('active');
            if($this.hasClass('active')){
                $this.text('Hide cart summary');
            }else{
                $this.text('Show cart summary');
            }
            $(div).slideToggle(300);
           return false;
        });
    };

    adjustCartCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input.enable-qty-selector');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id'),
                    productStock = $el.data('stock');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId,
                        productStock: productStock
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                var qtyMax = 1;

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    // Allow increase if there is no max or if there is a max and the qty is lower than the max
                    if (!qtyMax || (qtyMax && qty < qtyMax)) {
                        qty += 1;
                    }
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });

            // Add listeners on changing quantity at cart page
            $('body').on('change', '.js-qty__num', function (e){
               let $this = $(this);
               let currentQuan = $this.val();
               let stock = $this.data('stock');
               $this.closest('.marketing-sales').find('.cart-stock-warning').remove();
                $('#overStockIssueContainer').remove();
                if (currentQuan > stock) {
                    $('.update-cart').attr('disabled', 'disabled').addClass('out-of-stock');
                    if(stock > 1){
                        $this.closest('.marketing-sales').append('<span class="cart-stock-warning">Only ' + stock + ' Samples Are Available</span>');
                    }else{
                        $this.closest('.marketing-sales').append('<span id="overStockIssueContainer">Only ' + stock + ' Sample Is Available</span>');
                    }
                } else if(!$('.cart-stock-warning').length) {
                    $('.update-cart').removeAttr('disabled').removeClass('out-of-stock');
                }
            });
        }
    };

    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));